export default __webpack_public_path__ + "static/media/PF.1bf108c6.webp";